import Breadcrumb from "../components/Breadcrumb";
import { Globe, Smartphone, MessageSquare, Rocket, Code2, LineChart } from "lucide-react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";

export default function Services() {
  
  const services = [
    {
      icon: <Globe className="w-10 h-10 text-[#855109]" />,
      title: "Website Development",
      text: "We design and develop high-performance, responsive websites that help businesses build trust and attract more customers.Each website is crafted with modern UI/UX, fast loading speed, and SEO optimization.",
    },
    {
      icon: <Globe className="w-10 h-10 text-[#855109]" />,
      title: "Business Portfolio Websites",
      text: "Showcase your work professionally with visually appealing and engaging portfolio websites, built to highlight your strengths and attract clients.",
    },
    {
      icon: <Globe className="w-10 h-10 text-[#855109]" />,
      title: "Branding & Graphic Design",
      text: "Strong brands build strong businesses.We create unique logos, brand identity kits, color palettes, typography design, and complete branding systems.",
    },
    {
      icon: <Smartphone className="w-10 h-10 text-[#855109]" />,
      title: "Mobile App Development",
      text: "Build powerful Android & iOS apps with smooth UI and fast performance.",
    },
    {
      icon: <MessageSquare className="w-10 h-10 text-[#855109]" />,
      title: "WhatsApp Automation",
      text: "Automate customer interactions, send bulk messages, integrate chatbots, and improve lead generation using WhatsApp API automation.",
    },
    {
      icon: <Rocket className="w-10 h-10 text-[#855109]" />,
      title: "Digital Marketing",
      text: "Grow your brand with targeted campaigns, SEO, SMM, and lead generation.",
    },
    {
      icon: <Code2 className="w-10 h-10 text-[#855109]" />,
      title: "Custom Software",
      text: "Tailor-made software solutions to automate and scale your business.",
    },
    {
      icon: <LineChart className="w-10 h-10 text-[#855109]" />,
      title: "Branding & Design",
      text: "Creative brand identity, graphics, and design solutions that stand out.",
    },
  ];

  return (
    <>

      <Helmet>
        <title>Services – Website Development, Branding, Digital Marketing | ApnaWebX</title>
        <meta name="description" content="Explore our services: website development, app UI/UX, digital marketing, SEO, WhatsApp automation, branding & portfolio website design tailored for businesses." />
         <meta name="keywords" content="website services, branding agency, digital marketing company, SEO services, WhatsApp automation" />

        <link rel="canonical" href="https://apnawebx.com/" />

        {/* Open Graph */}
        <meta property="og:title" content="Services – Website Development & Digital Solutions" />
        <meta property="og:description" content="Professional services: websites, SEO, branding, WhatsApp automation & more." />
        <meta property="og:image" content="https://apnawebx.com/images/services-og.jpg" />
        <meta property="og:url" content="https://apnawebx.com/services" />



        <script type="application/ld+json">
          {`  {
          "@context": "https://schema.org",
        "@type": "Organization",
        "name": "ApnaWebX",
        "url": "https://apnawebx.com",
        "logo": "https://apnawebx.com/images/logo/apnawebxlogo.png",
        "description": "We provide website development, branding, SEO, WhatsApp automation & digital services.",
        "address": {
          "@type": "PostalAddress",
        "addressLocality": "Ahmedabad",
        "addressRegion": "Gujarat",
        "addressCountry": "IN"
  },
        "sameAs": [
        "https://www.instagram.com/apnawebx",
        "https://www.facebook.com/apnawebx"
        ]
}
        `}
        </script>

      </Helmet>



      {/* BREADCRUMB */}
      <Breadcrumb
        title="Our Services"
        paths={[{ label: "Services", link: null }]}
      />

      {/* SERVICE SECTION */}
      <section className="py-20 bg-[#fff7ef]">

        {/* TITLE */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#855109]">
            Our Services
          </h1>
          <p className="mt-4 text-gray-700 text-lg leading-relaxed">
            We provide complete digital solutions to take your business online,
            automate operations, and scale your brand with powerful modern technology.
          </p>
        </motion.div>

        {/* SERVICE GRID */}
        <div className="grid md:grid-cols-3 sm:grid-cols-2 gap-10 mt-16 px-6 md:px-12">
          {services.map((service, index) => (
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              key={index}
              className="group bg-[#fff7ef] p-10 rounded-2xl border border-[#eed7bc] shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <div className="flex items-center justify-center bg-white h-20 w-20 rounded-2xl shadow-md border border-[#eed7bc] mx-auto group-hover:scale-110 transition">
                {service.icon}
              </div>

              <h3 className="text-2xl font-bold text-[#855109] text-center mt-6">
                {service.title}
              </h3>

              <p className="text-gray-700 text-center mt-3 leading-relaxed">
                {service.text}
              </p>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-24 bg-[#855109] text-white px-10 py-14 md:p-14 rounded-3xl mx-6 md:mx-12 shadow-xl text-center">
          <h2 className="text-2xl md:text-4xl font-bold">
            Ready to Build Your Website?
          </h2>
          <p className="mt-3 text-white/80 text-lg">
            Get a free consultation and start your digital growth journey today.
          </p>
          <a
            href="/contact"
            className="inline-block px-8 py-4 bg-white text-[#855109] font-bold rounded-xl shadow-lg mt-6 hover:bg-[#f5e1c8] transition"
          >
            Get Free Quote
          </a>
        </div>

      </section>
    </>
  );
}
